import { render, staticRenderFns } from "./ViewTicketDetails.vue?vue&type=template&id=d2b8f1dc&scoped=true&lang=pug&"
import script from "./ViewTicketDetails.vue?vue&type=script&lang=js&"
export * from "./ViewTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./ViewTicketDetails.vue?vue&type=style&index=0&id=d2b8f1dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b8f1dc",
  null
  
)

export default component.exports